import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { resetMessage } from '../../redux/slices/form.js'
import { fetchDashboardMovies } from '../../redux/thunks/movies.js'
import { fetchDashboardSeries } from '../../redux/thunks/series.js'
import Dialog from '../Dialog/Dialog.js'
import SearchBar from '../SearchBar/SearchBar.js'
import Pagination from '../Pagination/Pagination.js'
import Table from '../Table/Table.js'
import Loading from '../Loading/Loading.js'

const DashboardContainer = (props) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { selected } = props
    const message = useSelector(state => state.form.message)
    const statusDashboard = useSelector(state => state.dashboard.status)
    const statusForm = useSelector(state => state.form.status)
    const statusCarousel = useSelector(state => state.carousel.status)

    const handleButtonCreate = () => {
        navigate(`/dashboard/form?selected=${selected}`)
    }

    const handleClick = (input) => {
        if (selected === 'movies') {
            dispatch(fetchDashboardMovies(input))
        } else if (selected === 'series') {
            dispatch(fetchDashboardSeries(input))
        }
    }

    return (
        <div className='fl-cl dashboardContainer__container'>
            {
                statusDashboard === 'loading'
                    || statusForm === 'loading'
                    || statusCarousel === 'loading' 
                    ? <Loading />
                    : undefined
            }
            {
                selected === undefined ?
                    (<div className='fl-cl dashboardContainer__hello'><h1>Hello Motherfucker</h1></div>) :
                    (
                        <div className='dashboardContainer__mainDiv'>
                            {message ? <Dialog dispatcher={resetMessage} id="dialogMessage" message={message} /> : undefined}
                            <h2>{selected === 'carousel' ? "Carousel" : selected === 'movies' ? "Peliculas" : "Series"}</h2>
                            <div className='fl-rw dashboard__container__searchAndCreate'>
                                {
                                    selected === 'carousel'
                                        ? undefined
                                        : selected === 'movies'
                                            ? <SearchBar onClick={handleClick} placeholder={`Escribe el nombre de la pelicula`} />
                                            : <SearchBar onClick={handleClick} placeholder={`Escribe el nombre de la serie`} />
                                }
                                <button onClick={handleButtonCreate}>Crear {selected === 'movies' ? "pelicula" : selected === 'series' ? "serie" : 'carousel'}</button>
                            </div>
                            <Table selected={selected} />
                            {
                                selected === 'movies' || selected === 'series'
                                    ? <Pagination selected={selected} />
                                    : undefined
                            }
                        </div>
                    )
            }
        </div>
    )
}

export default DashboardContainer;